// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--OVM6B","V2PieChartWrap":"V2PieChartWrap--pRFOe","V2PieChart":"V2PieChart--MPdHj","markerAnimationScale":"markerAnimationScale--Vkt9O"};